'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
The below implementation takes its cues from the following repo:
https://github.com/mathieudutour/deps-regex

We have modified it so that it also supports the syntax:

export a from 'b'
*/

var matchingName = '\\s*(?:[\\w${},\\s*]+)\\s*';
// strings passed to matchingDeps require a trailing opening bracket. This is to
// allow replaceImport to pass in partial paths, so we can match against a file
// pattern.
var matchAnyDep = '([^\'"`]+)(';
var matchingDeps = function matchingDeps() {
  var deps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : matchAnyDep;
  return 's*[\'"`])' + deps + '[\'"`]s*';
};

// $1 and $3 capture groups are used for 'require' statements, while $4 and $6
// are used for 'import' statements
var getRegexStr = function getRegexStr(deps) {
  return (
    // the first half of this regex matches require statements
    '((?:(?:var|const|let)' + matchingName + '=\\s*)?require\\(' + matchingDeps(deps) + '\\);?)' + (
    // the second half of this regex matches most imports
    '|((?:import|export)(?:(?:' + matchingName + 'from\\s*)|\\s*)' + matchingDeps(deps) + ';?)')
  );
};

exports.default = getRegexStr;


//////////////////
// WEBPACK FOOTER
// ./~/codesandboxer/dist/utils/getRegexMatchStr.js
// module id = 251
// module chunks = 168707334958949